(function () {
    'use strict';
    function initGiftCardRecipientForms() {
    var wrappers = document.querySelectorAll('[data-gift-card-recipient-form]');
    wrappers.forEach(function (wrapper) {
    initGiftCardRecipientForm(wrapper);
    });
    }

    function initGiftCardRecipientForm(wrapper) {
    var checkbox = wrapper.querySelector('[data-recipient-checkbox]');
    var fieldsContainer = wrapper.querySelector('[data-recipient-fields]');
    var emailInput = wrapper.querySelector('[data-recipient-email]');
    var nameInput = wrapper.querySelector('[data-recipient-name]');
    var messageInput = wrapper.querySelector('[data-recipient-message]');
    var sendOnInput = wrapper.querySelector('[data-recipient-send-on]');
    var offsetInput = wrapper.querySelector('[data-recipient-offset]');
    var sendToOptions = wrapper.querySelectorAll('[data-send-to-option]');

    if (!checkbox || !fieldsContainer) {
    return;
    }

    setSendOnDateBounds(sendOnInput);

    if (offsetInput) {
    offsetInput.value = new Date().getTimezoneOffset();
    }

    function setRecipientFieldsEnabled(enabled) {
    fieldsContainer.hidden = !enabled;

    [emailInput, nameInput, messageInput, sendOnInput, offsetInput].forEach(function (field) {
    if (!field) {
    return;
    }
    field.disabled = !enabled;
    });

    if (emailInput) {
    if (enabled) {
    emailInput.setAttribute('required', 'required');
    } else {
    emailInput.removeAttribute('required');
    emailInput.value = '';
    }
    }
    }

    function setSendToMode(mode) {
    var isRecipient = mode === 'recipient-email';
    checkbox.checked = isRecipient;
    checkbox.disabled = !isRecipient;
    sendToOptions.forEach(function (option) {
    var isActive = option.getAttribute('data-send-to-option') === mode;
    option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    setRecipientFieldsEnabled(isRecipient);
    }

    sendToOptions.forEach(function (option) {
option.addEventListener('click', function () {
setSendToMode(option.getAttribute('data-send-to-option'));
});
});
    
    setSendToMode('my-email');

    var form = wrapper.closest('form');
    if (form) {
    form.addEventListener('submit', function (event) {
    if (checkbox.checked && emailInput && !emailInput.checkValidity()) {
    event.preventDefault();
    emailInput.reportValidity();
    }
    });
    }
    }

    function setSendOnDateBounds(sendOnInput) {
    if (!sendOnInput) {
    return;
    }

    var today = new Date();
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 90);

    sendOnInput.min = formatDateForInput(today);
    sendOnInput.max = formatDateForInput(maxDate);
    }

    function formatDateForInput(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardRecipientForms);
    } else {
    initGiftCardRecipientForms();
    }
    })();
